import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const CIVIL = [
  ["solteiro", "Solteiro(a)"], ["casado", "Casado(a)"], ["casado_adquiridos", "Casado(a) · comunhão de adquiridos"],
  ["casado_geral", "Casado(a) · comunhão geral"], ["casado_separacao", "Casado(a) · separação de bens"],
  ["divorciado", "Divorciado(a)"], ["viuvo", "Viúvo(a)"],
];
export const emptySeller = () => ({ name: "", phone: "", email: "", civil_status: "" });

export function PartyRows({ list, setList, prefix = "ang-seller", addLabel = "Adicionar proprietário", canRemoveAll = false, required = false, max = 0, civil = true, treat = false, emailOptional = false }) {
  const up = (i, k, v) => setList(list.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  return (
    <div className="space-y-3">
      {list.map((s, i) => (
        <div key={i} className={`grid grid-cols-1 ${civil ? "sm:grid-cols-4" : "sm:grid-cols-[1fr_1fr_1fr_auto]"} gap-2 items-start`}>
          <div className="flex gap-1.5">
            {treat && (
              <div className="flex shrink-0 rounded-lg border border-slate-200 overflow-hidden" role="radiogroup" aria-label="Tratamento" data-testid={`${prefix}-treat-${i}`}>
                {["Sr.", "Sra."].map((t) => (
                  <button key={t} type="button" role="radio" aria-checked={s.title === t} onClick={() => up(i, "title", t)} data-testid={`${prefix}-treat-${i}-${t === "Sr." ? "sr" : "sra"}`}
                    className={`px-2.5 text-sm transition-colors ${s.title === t ? "bg-ec-green text-white" : "text-slate-600 hover:bg-slate-50"}`}>{t}</button>
                ))}
              </div>
            )}
            <Input placeholder="Nome" value={s.name} onChange={(e) => up(i, "name", e.target.value)} data-testid={`${prefix}-name-${i}`} />
          </div>
          <Input placeholder={required ? "Telemóvel" : "Telemóvel (opcional)"} value={s.phone || ""} onChange={(e) => up(i, "phone", e.target.value)} data-testid={`${prefix}-phone-${i}`} />
          <Input type="email" placeholder={required && !emailOptional ? "Email" : "Email (opcional)"} value={s.email || ""} onChange={(e) => up(i, "email", e.target.value)} data-testid={`${prefix}-email-${i}`} />
          <div className="space-y-1.5">
          <div className="flex gap-2">
            {civil && <Select value={CIVIL.some(([v]) => v === s.civil_status) ? s.civil_status : ""}
              onValueChange={(v) => setList(list.map((x, idx) => (idx === i ? { ...x, civil_status: v, ...(v.startsWith("casado") ? { de_facto_union: false } : {}) } : x)))}>
              <SelectTrigger data-testid={`${prefix}-civil-${i}`}><SelectValue placeholder="Estado civil" /></SelectTrigger>
              <SelectContent>{CIVIL.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
            </Select>}
            {(list.length > 1 || canRemoveAll) && (
              <button type="button" onClick={() => setList(list.filter((_, idx) => idx !== i))} data-testid={`${prefix}-remove-${i}`}
                className="text-slate-400 hover:text-red-600 transition-colors shrink-0">
                <Trash2 size={16} />
              </button>
            )}
          </div>
            {civil && s.civil_status && !s.civil_status.startsWith("casado") && (
              <label className="flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer">
                <input type="checkbox" checked={!!s.de_facto_union || s.civil_status === "uniao_facto"} onChange={(e) => up(i, "de_facto_union", e.target.checked)} data-testid={`${prefix}-union-${i}`} />
                Vive em união de facto
              </label>
            )}
          </div>
        </div>
      ))}
      {(!max || list.length < max) && <button type="button" onClick={() => setList([...list, emptySeller()])} data-testid={`${prefix}-add`}
        className="text-xs inline-flex items-center gap-1 text-ec-green hover:text-ec-gold transition-colors">
        <Plus size={14} /> {addLabel}
      </button>}
    </div>
  );
}
